import React, { useState, useEffect } from 'react';
import Styles from './InfoBox.module.css';
import goodImage from '../../assets/good.webp';
import moderateImage from '../../assets/moderate.webp';
import unhealthyImage from '../../assets/unhealthy.webp';
import veryUnhealthyImage from '../../assets/very-unhealthy.webp';
import hazardousImage from '../../assets/hazardous.webp';

const InfoBox = ({ pollutionData, location, forecastData }) => {
  const [currentTime, setCurrentTime] = useState(new Date());


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const renderPollutionData = () => {
    if (!pollutionData) {
      return <p>Click on the map to get pollution data.</p>;
    }

    const { pm25, no2, so2 } = pollutionData;

    // Determine AQI color and description based on pollution data
    let aqiColor = '';
    let aqiDescription = '';

    const aqi = pm25;

    if (aqi <= 50) {
      aqiColor = 'green';
      aqiDescription = 'The air is clean!';
    } else if (aqi <= 100) {
      aqiColor = 'yellow';
      aqiDescription = 'The air is moderately clean.';
    } else if (aqi <= 150) {
      aqiColor = 'orange';
      aqiDescription = 'The air is unhealthy for sensitive groups.';
    } else if (aqi <= 200) {
      aqiColor = 'red';
      aqiDescription = 'The air is unhealthy to breathe.';
    } else if (aqi <= 300) {
      aqiColor = 'purple';
      aqiDescription = 'The air is very unhealthy.';
    } else {
      aqiColor = 'maroon';
      aqiDescription = 'The air is hazardous.';
    }

    // Determine AQI image based on color
    let aqiImage;
    switch (aqiColor) {
      case 'green':
        aqiImage = goodImage;
        break;
      case 'yellow':
        aqiImage = moderateImage;
        break;
      case 'orange':
        aqiImage = unhealthyImage;
        break;
      case 'red':
        aqiImage = veryUnhealthyImage;
        break;
      case 'purple':
        aqiImage = veryUnhealthyImage;
        break;
      case 'maroon':
        aqiImage = hazardousImage;
        break;
      default:
        aqiImage = goodImage; // Default image
        break;
    }

    // Determine pollution level for NO2
    let no2Level = '';
    if (no2 < 0.00005) {
      no2Level = 'Low';
    } else if (no2 >= 0.00005 && no2 < 0.0001) {
      no2Level = 'Moderate Low';
    } else if (no2 >= 0.0001 && no2 < 0.00015) {
      no2Level = 'Moderate';
    } else if (no2 >= 0.00015 && no2 < 0.0002) {
      no2Level = 'Moderate High';
    } else {
      no2Level = 'High';
    }

    // Determine pollution level for SO2
    let so2Level = '';
    if (so2 < 0.00005) {
      so2Level = 'Low';
    } else if (so2 >= 0.00005 && so2 < 0.0001) {
      so2Level = 'Moderate Low';
    } else if (so2 >= 0.0001 && so2 < 0.0002) {
      so2Level = 'Moderate';
    } else if (so2 >= 0.0002 && so2 < 0.0003) {
      so2Level = 'Moderate High';
    } else {
      so2Level = 'High';
    }

    const lightenColor = (color) => {
      const colorMap = {
        green: '#9ACD32',
        yellow: '#e8e337',
        orange: '#fc9706',
        red: '#ff7f50',
        purple: '#FFA500',
        maroon: '#808080'
      };
    
      const lighterColorMap = {
        '#9ACD32': '#CDEB76', // Lighter green
        '#ADFF2F': '#E7FF99', // Lighter yellow-green
        '#fffd8d': '#FFFFBF', // Very light yellow
        '#FFD700': '#FFFFA0', // Light gold
        '#FFA500': '#FFC266', // Light orange
        '#808080': '#B0B0B0'  // Light gray
      };
  
    
      const hexColor = colorMap[color];
      return hexColor;
      
    };
    
    aqiColor = lightenColor(aqiColor);

    return (
      <div>
         {/* only display location.city if its availalbe */}
         {location && <h4>{location}</h4>}
         
        <div className={Styles.dateTime}>
          <p>Date: {currentTime.toLocaleDateString()}</p>
          <p>Time: {currentTime.toLocaleTimeString()}</p>
        </div>
        <div className={Styles.aqiBox} style={{ background: aqiColor}}>
          <img src={aqiImage} className={Styles.images} alt="mask" />
          <div>
            <p>{pm25}</p>
            <p>{aqiDescription}</p>
          </div>
        </div>
        <div className={Styles.otherGases}>
          <div className={Styles.gasValue } style={{ background: aqiColor }}>
            <h4>PM2.5</h4>
            <p>{pm25.toFixed(0)}</p>
          </div>
          <div className={Styles.gasValue} style={{ background: getColorCode(no2Level) }}>
            <h4>NO2</h4>
            <p>{no2Level}</p>
          </div>
          <div className={Styles.gasValue} style={{ background: getColorCode(so2Level) }}>
            <h4>SO2</h4>
            <p>{so2Level}</p>
          </div>
        </div>

        {/* forecast data */}
        {forecastData.length > 0 && 
        <div className={Styles.otherGases_}>
      {forecastData.map(({ date, concentration }, index) => (
        <div key={index} className={Styles.gasValue_} style={{ background: lightenColor(getColor(concentration)) }}>
          <h3>{date}</h3>
          <p>{concentration.toFixed(0)}</p>
        </div>
      ))} 
    </div>}
      </div>
    );
  };
  const getColor = (concentration) => {
    let aqiColor;
  
    if (concentration <= 50) {
      aqiColor = 'green';
    } else if (concentration <= 100) {
      aqiColor = 'yellow';
    } else if (concentration <= 150) {
      aqiColor = 'orange';
    } else if (concentration <= 200) {
      aqiColor = 'red';
    } else if (concentration <= 300) {
      aqiColor = 'purple';
    } else {
      aqiColor = 'maroon';
    }
  
    return aqiColor;
  };

  const getColorCode = (level) => {
    switch (level) {
      case 'Low':
        return '#9ACD32'; // Light green
      case 'Moderate Low':
        return '#ADFF2F'; // Green-yellow
      case 'Moderate':
        return '#fffd8d'; // Very light yellow
      case 'Moderate High':
        return '#FFD700'; // Gold
      case 'High':
        return '#FFA500'; // Orange
      default:
        return '#808080'; // Dark gray (default color)
    }
  };
  

  return (
    <div className={Styles.infoBox} rel='preload'>
      {renderPollutionData()}
    </div>
  );
};

export default InfoBox;
